function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import cn from 'classnames';
import forIn from 'lodash/forIn';
import get from 'lodash/get';
import Alert from 'components/Alert';
import * as selectors from '../../selectors';
import * as shapes from '../../shapes';
import messages from '../../messages';
var _React_PureComponent;
class InvitationInfo extends (_React_PureComponent = React.PureComponent) {
    get message() {
        return get(messages.headers.acceptInvitation, this.props.invitation.subject);
    }
    render() {
        if (!this.props.invitation) {
            return null;
        }
        const messageValues = {};
        forIn(this.props.invitation.inviter, (value, key)=>{
            messageValues[key] = /*#__PURE__*/ _jsx("b", {
                children: value
            });
        });
        return /*#__PURE__*/ _jsx("div", {
            id: "InvitationInfo",
            className: cn(this.props.className),
            children: /*#__PURE__*/ _jsx(Alert, {
                type: "info",
                message: this.message,
                messageValues: messageValues
            })
        });
    }
}
_define_property(InvitationInfo, "propTypes", {
    className: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.object
    ]),
    invitation: shapes.invitation
});
const mapStateToProps = ()=>(state)=>({
            invitation: selectors.invitation(state)
        });
const ConnectedInvitationInfo = connect(mapStateToProps)(InvitationInfo);
export default ConnectedInvitationInfo;
